import React, { useState } from 'react';
import { ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { PhaseTimeline } from '../roadmap/PhaseTimeline';
import CardDeck from '../roadmap/CardDeck';
import CanvasPreview from '../roadmap/CanvasPreview';
import { useWindowSize } from '@/hooks/use-window-size';
import { cn } from '@/lib/utils';

const phases = [
  {
    id: 'phase-zero',
    title: 'Phase Zero',
    description: 'Onboarding early access users. Posts are all chronological on a feed.',
    isCompleted: false,
  },
  {
    id: 'phase-one',
    title: 'Phase One',
    description: 'Every 24 hours, we pick the best performing video to be vaulted. Vaulted videos become part of FOMO permanently. In addition.. we will release a feature that allows exploration of content in a whole new way.',
    isCompleted: false,
  },
  {
    id: 'phase-two',
    title: 'Phase Two',
    description: 'Canvas, explore a map of content that moves away from boring content feeds, and features a new method of interaction and posting your creations.',
    isCompleted: false,
  }
];

export const RoadmapSection = ({
  isMobile = false,
  onNext
}: {
  isMobile?: boolean;
  onNext?: () => void;
}) => {
  const [selectedPhaseId, setSelectedPhaseId] = useState<string | null>(null);
  const { width } = useWindowSize();
  const isMobileView = isMobile || (width !== undefined && width < 768);

  const handlePhaseSelect = (phaseId: string) => {
    setSelectedPhaseId(prevId => prevId === phaseId ? null : phaseId);
  };

  return (
    <div className={cn(
      `${isMobileView ? 'lg:hidden' : 'hidden lg:flex'} flex-col gap-6`,
      `${isMobileView ? 'mt-12 w-full' : ''}`,
      "transition-all duration-300"
    )}>
      <h2 className={`text-lg font-medium text-primary/80 ${isMobileView ? 'text-center' : 'text-left'}`}>
        Roadmap
      </h2>
      
      <div className="grid grid-cols-1 gap-4">
        <PhaseTimeline 
          phases={phases} 
          currentPhaseId="phase-zero"
          selectedPhaseId={selectedPhaseId}
          onPhaseSelect={handlePhaseSelect}
        />
        
        {selectedPhaseId === 'phase-one' && isMobileView && (
          <div className="mt-6 animate-fade-in">
            <div className="bg-black/20 rounded-xl p-5 backdrop-blur-sm border border-primary/10">
              <h3 className="text-lg font-medium text-primary mb-3">Daily Vaulted Content</h3>
              <p className="text-sm text-muted-foreground mb-4">
                Every day, the best performing video is permanently vaulted in our collection. 
                These gems become part of FOMO's exclusive library.
              </p>
              <CardDeck />
            </div>
          </div>
        )}
        
        {selectedPhaseId === 'phase-two' && isMobileView && (
          <div className="mt-6 animate-fade-in">
            <div className="bg-black/20 rounded-xl p-5 backdrop-blur-sm border border-primary/10">
              <h3 className="text-lg font-medium text-primary mb-3">Canvas Experience</h3>
              <p className="text-sm text-muted-foreground mb-4">
                Move away from traditional content feeds with our innovative canvas approach. 
                Explore content spatially and discover new ways to interact with creators.
              </p>
              <CanvasPreview />
            </div>
          </div>
        )}
      </div>

      {onNext && (
        <Button onClick={onNext} className="mt-6 w-full sm:w-auto self-end" size="lg">
          Next <ArrowRight />
        </Button>
      )}
    </div>
  );
};
